function makePaymentAuthorizationPath(invoiceGroupNumber) {
  return `/invoices/${invoiceGroupNumber}/info`;
}

export default makePaymentAuthorizationPath;
